import { SVGProps } from '../types';

const AMEXIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H42C44.2091 0 46 1.79086 46 4V28C46 30.2091 44.2091 32 42 32H4C1.79086 32 0 30.2091 0 28V4Z"
      fill="#1F72CD"
    />
    <path
      d="M13.0234 12.4691V11.3334H18.0908L19.2021 13.8275L20.2881 11.3334H32.9326L34.2148 12.806L35.5908 11.3334H41.4678L37.2129 16.1918L41.4678 21.0082L35.498 20.9955L34.1748 19.4955L32.7607 20.9955H21.1377V19.7953L20.6396 20.9955H17.748L17.25 19.8197V20.9955H11.6611L11.0312 19.4554H9.59277L8.96387 20.9955H3.88574L8.12695 11.3334H12.46L13.0234 12.4691ZM6.13574 19.6371H7.94434L8.58398 18.0844H12.043L12.6826 19.639H16.0596V14.2054L18.4668 19.639H19.9346L22.3281 14.2054L22.3418 19.639H23.9834V12.7054H21.2852L19.2822 17.4037L17.1094 12.7054H14.3984V19.2572L11.585 12.7054H9.10938C9.0947 12.7396 6.16325 19.573 6.13574 19.6371ZM25.4854 19.6351H32.0566L34.1748 17.3383L36.2158 19.6351H38.3506L35.248 16.1898L38.3506 12.7054H36.3086L34.2012 14.976L32.1602 12.7054H25.4854V19.6351ZM31.2979 14.14L33.1152 16.1635L31.2178 18.1996H27.1328V16.8177H30.7744V15.4066H27.1328V14.14H31.2979ZM11.4521 16.6478H9.17383L10.3135 13.8783L11.4521 16.6478Z"
      fill="white"
    />
  </svg>
);

export { AMEXIcon };
